import axiosInstance from "../../utils/axiosInstance";

const AdminClient = {
  getAll: () => axiosInstance.get("/users"),
  getById: (id) => axiosInstance.get(`/users/${id}`),
  createAdmin: (payload) => axiosInstance.post("/users/create", payload),
  updateAdmin: (id, payload) => axiosInstance.put(`/users/${id}`, payload),
  deleteAdmin: (id) => axiosInstance.delete(`/users/${id}`),
  replaceRoles: (id, roleNames) => axiosInstance.put(`/users/${id}/roles`, roleNames),
  assignRole: (id, roleId) => axiosInstance.post(`/users/${id}/roles/${roleId}`),
  removeRole: (id, roleId) => axiosInstance.delete(`/users/${id}/roles/${roleId}`),
};

export default AdminClient;
